<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/karst/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "5.5 x 8.5 Stone Soft Bound Notebook",
		src: imagesGlob["../../images/brands/karst/products/swaggerproductpagewebsiteholidaykitskarst55-x-85-stone-soft-bound-notebook.png"].default
	},
	{
		title: "Pro Series Notebook",
		src: imagesGlob["../../images/brands/karst/products/swaggerproductpagewebsiteholidaykitskarstpro-series-notebook.png"].default
	},
	{
		title: "5.5 x 8.5 Stone Bound Notebook",
		src: imagesGlob["../../images/brands/karst/products/swaggerproductpagewebsiteholidaykitskarst55-x-85-stone-bound-notebook.png"].default
	},
	{
		title: "Pocket Stone Paper Notebook",
		src: imagesGlob["../../images/brands/karst/products/swaggerproductpagewebsiteholidaykitskarstpocket-stone-paper-notebook.png"].default
	},
]
</script>

<template lang="pug">
.page.page--brand.karst
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/karst/logo.png')
				h1 Custom Karst
			.image
				img(src='@static/images/brands/karst/hero.jpg' alt='Stack of Karst Stone Paper notebooks in neutral tones on a wooden desk, placed beside a potted plant.')
	section.section.section--subhero
		.section__content
			.copy
				h3 Better Tools. Better Work. Better Tomorrow.
				p Custom Karst by Swagger redefines what it means to put pen to paper. With its innovative Stone Paper™, Karst transforms recycled stone into smooth, durable, and sustainable notebooks, planners, and journals. Free from trees, water, and bleaches, every page is designed for those who value quality, creativity, and conscious impact. This is stationery built to last, crafted for ideas worth keeping.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="karst")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/karst/banner.png' alt='Karst visual showing a block of stone transforming seamlessly into the pages of an open notebook against a teal background.')
			.section__content
				.copy
					h2 IDEAS THAT LEAVE A MARK, NOT A FOOTPRINT
					p Karst is a Certified B Corporation setting a new standard in sustainable design. Their Stone Paper™ production process uses less energy, generates fewer emissions, and conserves natural resources compared to traditional paper-making. By planting a tree for every purchase and operating as a carbon-neutral business, Karst ensures that big thinking can go hand-in-hand with positive impact. From innovation to execution, they’re proving that bold ideas deserve an equally bold commitment to the planet.

		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>